import accommodationList from './AccommodationList/fr.json';
import chat from './Chat/fr.json';
import common from './Common/fr.json';
import consent from './Consent/fr.json';
import forgotPassword from './ForgotPassword/fr.json';
import main from './Main/fr.json';
import signIn from './SignIn/fr.json';
import signUp from './SignUp/fr.json';
import transportList from './TransportList/fr.json';

export default {
  accommodationList,
  chat,
  common,
  consent,
  forgotPassword,
  signIn,
  signUp,
  transportList,
  main
};
